require('./cardChargeNoBalanceStep.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WizardError = require('components/commons/wizardError/wizardError');

class CardChargeNoBalanceStep extends React.Component {
    render() {
        const { immCard } = this.props;
        const title = formatText('moneySavingsRequest-noBalanceErrorTitle');
        const cardAlias = immCard.getIn(['alias', 'current']);
        const goBackButtonLabel = formatText('moneySavingsRequest-backLink', [cardAlias]).toUpperCase();
        const linkToMovements = `myprofile/global`;
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToMovements
        };

        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8 card-charge-no-balance">
                <WizardError
                    errorMessage={title}
                    mainButton={goBackButton}>
                    <section className="row">
                        <div className="col-xs-5">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                        </div>
                        <div className="col-xs-7">
                            <FormattedText value="moneySavingsRequest-noBalanceErrorMessage" />
                        </div>
                    </section>
                </WizardError>
            </div>
        );
    }
}

CardChargeNoBalanceStep.propTypes = {
    immCard: PropTypes.object.isRequired
};
module.exports = CardChargeNoBalanceStep;
